export default (params) => ({
  trigger: {
    name: 'content_blocks.visual_entrances.click_cta',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'start_flow',
      params: {
        sub_feature: 'energy_contract',
      },
    },
    nonInt: true,
  },
});
